import { Injectable } from '@angular/core';
import { Path } from '../../constants/paths';
import { Observable, Subject, tap } from 'rxjs';
import { HttpService } from '../http/http.service';
import { PermissionService } from '../permission/permission.service';
import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  private warehouseChangedSubject = new Subject<void>();
  warehouseChanged$ = this.warehouseChangedSubject.asObservable();
  private _availableWarehouse: any[] = [];
  private _selectedWarehouse: string = '';

  get availableWarehouse(): any[] {
    try {
      const data = localStorage.getItem('available_warehouse');
      this._availableWarehouse = JSON.parse(data || '')
    } catch (e) {
      this.authService.logout()
    }
    return this._availableWarehouse;
  }

  set availableWarehouse(value: any[]) {
    localStorage.setItem('available_warehouse', JSON.stringify(value));
    this._availableWarehouse = value;
  }

  get selectedWarehouse(): string {
    try {
      const data = localStorage.getItem('warehouse_code') || '';
      this._selectedWarehouse = data
    } catch (e) {
      this.authService.logout()
    }
    return this._selectedWarehouse;
  }

  set selectedWarehouse(value: string) {
    localStorage.setItem('warehouse_code', value);
    this._selectedWarehouse = value;
  }

  constructor(
    private http: HttpService,
    private permissionService: PermissionService,
    private authService: AuthService
  ) {}

  getWarehouse(): Observable<any> {
    return this.http.get(
      Path.LOGIN.GET_WAREHOUSE,
      null,
      null,
      false,
      true,
      false,
    );
  }

  login(parameters: {}): Observable<any> {
    return this.http
      .get(Path.LOGIN.GET, parameters, null, false, true, false)
      .pipe(
        tap((response: any) => {
          console.warn('login response', response);
          localStorage.setItem('token', response.token);

          // After login success and receiving user data
          if (response && response.success.results.module_permissions) {
            this.permissionService.setPermissions(
              response.success.results.module_permissions,
            );
          }
        }),
      );
  }

  webUserCutomerMappingDetails(): any {
    const customerDetails = localStorage.getItem('customer_details');

    if (!customerDetails) {
      return null;
    }
    return JSON.parse(customerDetails);
  }

  isWebUserCustomerMappingAll(): boolean {
    const customerDetails = this.webUserCutomerMappingDetails();
    if (!customerDetails) {
      return true; // Default to showing if no customer details exist
    }

    try {
      const details = customerDetails;
      return details.customer_id === 0;
    } catch (e) {
      console.error('Error parsing customer details from localStorage', e);
      return true; // Default to showing on error
    }
  }

  notifyWarehouseChanged(): void {
    this.warehouseChangedSubject.next();
  }
}
